import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { ClientSettingName, IClientSettings, IVacationBidSettingsValue } from "@vmosolutions/oc-interfaces";
import { getClientSetting } from "../actions/App.Actions";

export interface IPermissionsState {
  docManager: boolean;
  vacationBidding: IVacationBidSettingsValue;
}

const defaultVacationBiddingSetting: IVacationBidSettingsValue = { enabled: false, showSlotIdYear: true };

const initialState: IPermissionsState = {
  docManager: false,
  vacationBidding: defaultVacationBiddingSetting,
};

export const getDocManagerSetting = createAsyncThunk("permissions/docmanager", async () => {
  const docManagerSettings: IClientSettings = await getClientSetting(ClientSettingName.DocManager);
  return docManagerSettings?.setValue?.enabled;
});

/**
 * The whole setting is kept, not just the enabled flag, so the vacation bid pages can also read
 * display options such as `showSlotIdYear`. A missing or disabled setting collapses to the
 * default, so `enabled` is always a real boolean.
 */
export const getVacationBiddingSetting = createAsyncThunk("permissions/vacationBidding", async () => {
  const setting: IClientSettings | null = await getClientSetting(ClientSettingName.VacationBidding);
  const value = setting?.setValue as IVacationBidSettingsValue | undefined;
  return value?.enabled === true
    ? { ...defaultVacationBiddingSetting, ...value, enabled: true }
    : defaultVacationBiddingSetting;
});

export const Permissions: any = createSlice({
  name: "permissions",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getDocManagerSetting.fulfilled, (state, action: PayloadAction<boolean>) => {
      state.docManager = action.payload;
    });
    builder.addCase(
      getVacationBiddingSetting.fulfilled,
      (state, action: PayloadAction<IVacationBidSettingsValue>) => {
        state.vacationBidding = action.payload;
      }
    );
  },
});

export default Permissions.reducer;
